import React from 'react';
import { Form, Input, Button } from 'antd';
import SketchToolbar from './SketchToolbar';
import { DeleteOutlined } from '@ant-design/icons';
import { Sketch } from '../../../../models/sketch.model';
import PointConfig from './SketchesConfiguration/PointConfig';
import LineConfig from './SketchesConfiguration/LineConfig';
import PolygonConfig from './SketchesConfiguration/PolygonConfig';
import TextConfig from './SketchesConfiguration/TextConfig';
import { Controller, useFormContext } from 'react-hook-form';
import './SketchDrawerContent.scss';

interface SketchDrawerContentProps {
  state: string;
  onFinish: (values: Pick<Sketch, 'title' | 'description'>) => void;
  drawingMode: string;
  setDrawingMode: (mode: string) => void;
  resetEntities: () => void;
  onSaveSketchItem: () => void;
  selectedItemType?: string;
  onDeleteItem: () => void;
  onSaveConfig: () => void;
  isCreating?: boolean;
}

const SketchDrawerContent: React.FC<SketchDrawerContentProps> = ({
  state,
  onFinish,
  drawingMode,
  setDrawingMode,
  resetEntities,
  onSaveSketchItem,
  selectedItemType,
  onDeleteItem,
  onSaveConfig,
  isCreating,
}) => {
  const { control, handleSubmit, formState } = useFormContext<Pick<Sketch, 'title' | 'description'>>();

  if (state === 'create') {
    return (
      <form onSubmit={handleSubmit(onFinish)}>
        <Form.Item
          label="Title"
          className="sketch-drawer-content__form-item"
          layout="vertical"
          validateStatus={formState.errors.title ? 'error' : undefined}
          help={formState.errors.title?.message}
        >
          <Controller name="title" control={control} rules={{ required: 'Sketch Name is required.' }} render={({ field }) => <Input {...field} />} />
        </Form.Item>
        <Form.Item label="Description" className="sketch-drawer-content__form-item" layout="vertical">
          <Controller name="description" control={control} render={({ field }) => <Input.TextArea {...field} />} />
        </Form.Item>
        <Button htmlType="submit" className="sketch-drawer-content__submit-btn">
          <img src="/assets/pencil-icon.svg" alt="" className="sketch-drawer-content__submit-icon" />
          {isCreating ? 'Create a New Sketch' : 'Update Sketch'}
        </Button>
      </form>
    );
  }

  if (state === 'view') {
    return (
      <div className="sketch-view">
        <SketchToolbar drawingMode={drawingMode} setDrawingMode={setDrawingMode} resetEntities={resetEntities} />
        <Button onClick={onSaveSketchItem} className="sketch-drawer-content__save-item-btn">
          Save Sketch Item
        </Button>
      </div>
    );
  }

  if (state === 'configure') {
    return (
      <div>
        {selectedItemType === 'point' && <PointConfig />}
        {selectedItemType === 'line' && <LineConfig />}
        {selectedItemType === 'polygon' && <PolygonConfig />}
        {selectedItemType === 'text' && <TextConfig />}

        <div className="sketch-drawer-content__actions">
          <Button danger onClick={onDeleteItem}>
            <DeleteOutlined /> Delete Feature
          </Button>
          <Button type="primary" className="sketch-drawer-content__save-btn" onClick={onSaveConfig}>
            Save and Close
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default SketchDrawerContent;
